<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-8">
        <h1>{{title}}</h1>
      </div>
      <div class="col-12 col-sm-4 mb-2">
        <button class="btn btn-sm btn-success float-right" (click)="addZoneDialog()"><i class="fas fa-plus mr-1"></i> Add
          Zone</button>
      </div>
      <div class="col-12">
        <div class=" ">
          <input type="text" class="form-control form-control-sm input-custom" (keyup)="applyFilter($event)"
            placeholder="Search" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important;">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{title}}</span>

          <a type="button" class="float-right mr-4" (click)="importZoneCSV()">
            <i class="fa fa-upload mr-1" aria-hidden="true"></i> Import CSV
          </a>

          <a type="button" class="float-right mr-4" (click)="exportSampleCSV()">
            <i class="fas fa-download mr-1" aria-hidden="true"></i> Sample CSV
          </a>
          
          <a type="button" class="float-right mr-4" (click)="exportZoneCSV()">
            <i class="fa fa-cloud-download-alt mr-1" aria-hidden="true"></i> Export CSV
          </a>

        <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
          <ng-container matColumnDef="zoneId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone ID</th>
            <td mat-cell *matCellDef="let element"> {{element.zoneId}} </td>
          </ng-container>
  
          <ng-container matColumnDef="zoneName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone Name</th>
            <td mat-cell *matCellDef="let element"> {{element.zoneName}} </td>
          </ng-container>
  
          <ng-container matColumnDef="parkingType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Parking Type </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.parkingType == 1;">Paid</span>
              <span *ngIf="element.parkingType == 2;">Permitted</span>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Parking Service</th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>
  
          <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
            <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
          </ng-container>
  
          <ng-container matColumnDef="gracePeriod">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Grace Period</th>
            <td mat-cell *matCellDef="let element"> {{element.gracePeriod}} </td>
          </ng-container>
  
          <ng-container matColumnDef="multipleTicket">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Multiple Ticket</th>
            <td mat-cell *matCellDef="let element"> 
              <span *ngIf="element.multipleTicket == true">Yes</span>
              <span *ngIf="element.multipleTicket == false">No</span>
            </td>
          </ng-container>
  
          <!-- <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"> 
              <span *ngIf="element.status == 1; else inactive">Active</span>
              <ng-template #inactive><span>InActive</span></ng-template>
            </td>
          </ng-container> -->
  
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
  
              <button mat-icon-button matTooltip="Click to Edit" (click)="updateZoneDialog(element)" class="iconbutton text-warning float-left">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>

              <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePromptU">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button> 
              
              <div class="modal fade" id="deletePromptU" tabindex="-1" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title orange-text" id="deletePromptLabel">Delete Zone </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      </div>
                      <div class="modal-body">
                        Are you sure you want to delete this zone?
                      </div>
                      <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                      <button type="button" class="btn btn-danger" (click)="deleteZone(tempId)" data-dismiss="modal">Confirm</button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>

